import { List, Form, Select, Icons, Table, Button } from '@pankod/refine-antd'
import { getAllRoles, getUsersByRole } from 'users'
import {
  getQuestionsByCreator,
  getAllWorkRequest,
  getQuestionsBySubjectinCharge,
  getPaperTemplateListByPm,
  getTestTrackListByPm,
  getPaperRequestForPsAndPa,
  getPaperRequestForPm,
  getEvaluationRequestsByDm,
  getEvaluationRequestsByEvaluationIncharge,
  getEvaluationByEvaluator,
  getEvaluationRequestList,
  getProductListByPm,
} from 'gql/query'
import { useEffect, useState } from 'react'
import { CSVLink } from 'react-csv'

import {
  showPaperApprover,
  showPaperSetter,
  showProductManager,
  showProductManagerPaperTemplates,
  showProductManagerProducts,
  showProductManagerTestTrack,
} from './paper_user'
import { showDeliveryManager, showEvaluationIncharge, showEvaluator } from './evaluation_user'

const productManagerOptions = [
  { label: 'Products', value: 'products' },
  { label: 'Paper Templates', value: 'paper_templates' },
  { label: 'Test Tracks', value: 'test_tracks' },
  { label: 'Paper Requests', value: 'paper_requests' },
]

export const ReportList: React.FC = () => {
  const { Option } = Select
  const [form] = Form.useForm()
  const [roleList, setRoleList] = useState([] as any[])
  const [userList, setUserList] = useState([] as any[])
  const [role, setRole] = useState('')
  const [selectedUserName, setSelectedUserName] = useState('')
  const [selectedUser, setSelectedUser] = useState('')
  const [tableData, setTableData] = useState([] as any[])
  const [userTable, setUserTable] = useState([] as any[])
  const [showlist, setShowList] = useState([] as any[])
  const [reportType, setReportType] = useState<string>('')

  const [wrFilter, setWRFilter] = useState<string>('')
  const [limit, setLimit] = useState(10)
  const [offset, setOffSet] = useState(0)

  const { ExportOutlined, ArrowDownOutlined } = Icons

  useEffect(() => {
    getAllRoles().then((response: any) => {
      setRoleList(response.authRoles)
    })
  }, [])

  useEffect(() => {
    getUsersByRole(role).then((response: any) => {
      setUserList(response?.authUserRoles)
    })
  }, [role])

  useEffect(() => {
    let userName = userList.find(user => user?.user?.id === selectedUser)?.user?.displayName
    if (userName) {
      setSelectedUserName(userName?.replace(/ /g, '_'))
    }
    let userDetails: any[] = [
      {
        userName: userName,
        UserRole: role,
      },
    ]

    let userType = ''
    if (role === 'qcreator') {
      userType = 'creator_id'
      getQuestionsByCreator(selectedUser, userType).then((response: any) => {
        response.work_requests.forEach((data: any) => {
          let mockObj = {
            'Work Request Name': data.name,
            'Total No of Questions': data.count,
            'Total No of Questions Created': data.questions.length,
            'For Approval': getQuestionStatus(data.questions, 'For Approval'),
            'For Review': getQuestionStatus(data.questions, 'For Review'),
            Published: getQuestionStatus(data.questions, 'Published'),
            Retired: getQuestionStatus(data.questions, 'Retired'),
            'Rejected at Approval': getQuestionStatus(data.questions, 'Rejected For Approval'),
            'For Review (Require Amending)': getQuestionStatus(data.questions, 'For Review (Require Amending)'),
            Open: getQuestionStatus(data.questions, 'Open'),
            'Open (Require Amending)': getQuestionStatus(data.questions, 'Open (Require Amending)'),
            'Rejected at Review': getQuestionStatus(data.questions, 'Rejected at Review'),
          }
          userDetails.push(mockObj)
        })
        setTableData(userDetails)
      })
    } else if (role === 'variantcreator') {
      userType = 'creator_id'
      getQuestionsByCreator(selectedUser, userType).then((response: any) => {
        response.work_requests.forEach((data: any) => {
          let mockObj = {
            'Work Request Name': data.name,
            'Total No of Questions': data.count,
            'Total No of Questions Created': data.questions.length,
            'For Approval': getQuestionStatus(data.questions, 'For Approval'),
            'For Review': getQuestionStatus(data.questions, 'For Review'),
            Published: getQuestionStatus(data.questions, 'Published'),
            Retired: getQuestionStatus(data.questions, 'Retired'),
            'Rejected at Approval': getQuestionStatus(data.questions, 'Rejected For Approval'),
            'For Review (Require Amending)': getQuestionStatus(data.questions, 'For Review (Require Amending)'),
            Open: getQuestionStatus(data.questions, 'Open'),
            'Open (Require Amending)': getQuestionStatus(data.questions, 'Open (Require Amending)'),
            'Rejected at Review': getQuestionStatus(data.questions, 'Rejected at Review'),
          }
          userDetails.push(mockObj)
        })
        setTableData(userDetails)
      })
    } else if (role === 'qapprover') {
      getAllWorkRequest(wrFilter, 1000, offset, 'created_by', 'asc').then((response: any) => {
        let filteredWorkRequest: any = []
        response.work_requests.forEach((data: any) => {
          data.approver_ids.forEach((approver: any) => {
            let isExist = approver.approver_ids.find((id: any) => id === selectedUser)
            if (isExist) {
              filteredWorkRequest.push(data)
            }
          })
        })
        let userDetails: any = []
        filteredWorkRequest.forEach((request: any) => {
          let mockObj = {
            'Work Request Name': request.name,
            'Total No of Questions': request.count,
            'For Approval': getQuestionStatus(request.questions, 'For Approval'),
            'For Review': getQuestionStatus(request.questions, 'For Review'),
            Published: getQuestionStatus(request.questions, 'Published'),
            Retired: getQuestionStatus(request.questions, 'Retired'),
            'Rejected at Approval': getQuestionStatus(request.questions, 'Rejected For Approval'),
            'For Review (Require Amending)': getQuestionStatus(request.questions, 'For Review (Require Amending)'),
            Open: getQuestionStatus(request.questions, 'Open'),
            'Open (Require Amending)': getQuestionStatus(request.questions, 'Open (Require Amending)'),
            'Rejected at Review': getQuestionStatus(request.questions, 'Rejected at Review'),
          }
          userDetails.push(mockObj)
        })
        setTableData(userDetails)
      })
    } else if (role === 'qreviewer') {
      getAllWorkRequest(wrFilter, 1000, offset, 'created_by', 'asc').then((response: any) => {
        let filteredWorkRequest: any = []
        response.work_requests.forEach((data: any) => {
          let isExist = data.reviewer_ids?.find((id: any) => id === selectedUser)
          if (isExist) {
            filteredWorkRequest.push(data)
          }
        })
        let userDetails: any = []
        filteredWorkRequest.forEach((request: any) => {
          let mockObj = {
            'Work Request Name': request.name,
            'Total No of Questions': request.count,
            'For Approval': getQuestionStatus(request.questions, 'For Approval'),
            'For Review': getQuestionStatus(request.questions, 'For Review'),
            Published: getQuestionStatus(request.questions, 'Published'),
            Retired: getQuestionStatus(request.questions, 'Retired'),
            'Rejected at Approval': getQuestionStatus(request.questions, 'Rejected For Approval'),
            'For Review (Require Amending)': getQuestionStatus(request.questions, 'For Review (Require Amending)'),
            Open: getQuestionStatus(request.questions, 'Open'),
            'Open (Require Amending)': getQuestionStatus(request.questions, 'Open (Require Amending)'),
            'Rejected at Review': getQuestionStatus(request.questions, 'Rejected at Review'),
          }
          userDetails.push(mockObj)
        })
        setTableData(userDetails)
      })
    } else if (role === 'subjectincharge') {
      getQuestionsBySubjectinCharge(selectedUser).then((response: any) => {
        response.work_requests.forEach((data: any) => {
          let mockObj = {
            'Work Request Name': data.name,
            'Total No of Questions': data.count,
            'Total No of Questions Created': data.questions.length,
            'For Approval': getQuestionStatus(data.questions, 'For Approval'),
            'For Review': getQuestionStatus(data.questions, 'For Review'),
            Published: getQuestionStatus(data.questions, 'Published'),
            Retired: getQuestionStatus(data.questions, 'Retired'),
            'Rejected at Approval': getQuestionStatus(data.questions, 'Rejected For Approval'),
            'For Review (Require Amending)': getQuestionStatus(data.questions, 'For Review (Require Amending)'),
            Open: getQuestionStatus(data.questions, 'Open'),
            'Open (Require Amending)': getQuestionStatus(data.questions, 'Open (Require Amending)'),
            'Rejected at Review': getQuestionStatus(data.questions, 'Rejected at Review'),
          }
          userDetails.push(mockObj)
        })
        setTableData(userDetails)
      })
    } else if (role === 'productmanager') {
      if (reportType === 'products') {
        getProductListByPm(selectedUser).then((data: any) => {
          data?.products?.forEach((product: any) => {
            let tempObj = {
              'Product Created': product?.name,
              'Test Events Associated': product?.test_event?.length,
              'Paper Templates Associated': product?.paper_templates?.length,
              'Papers Associated': product?.papers?.length,
            }
            userDetails.push(tempObj)
          })
          setTableData(userDetails)
        })
      } else if (reportType === 'test_tracks') {
        getTestTrackListByPm(selectedUser).then((data: any) => {
          data?.test_tracks?.forEach((test_track: any) => {
            let tempObj = {
              'Test Track Created': test_track?.name,
              'Paper Templates Associated': test_track?.paper_templates?.length,
              'Papers Associated': test_track?.papers?.length,
            }
            userDetails.push(tempObj)
          })
          setTableData(userDetails)
        })
      } else if (reportType === 'paper_templates') {
        getPaperTemplateListByPm(selectedUser).then((data: any) => {
          data?.paper_templates?.map((paper_template: any) => {
            let tempObj = {
              'Paper Tenplate Created': paper_template?.name,
              'No of Subsection Associated': paper_template?.paper_template?.length,
              'Papers Associated': paper_template?.papers?.length,
            }
            userDetails.push(tempObj)
          })
          setTableData(userDetails)
        })
      } else if (reportType === 'paper_requests') {
        getPaperRequestForPm(selectedUser).then((data: any) => {
          console.log(data)
          data?.paper_requests?.forEach((eachRequest: any) => {
            let tempObj = eachRequest && {
              'Paper Requests Created': eachRequest?.name,
              'Paper Template': eachRequest?.paper_template?.name,
              'Test Track': eachRequest?.test_track?.name,
              Product: eachRequest?.product?.name,
              'Test Event': eachRequest?.test_event?.name,
            }
            userDetails.push(tempObj)
          })
          setTableData(userDetails)
        })
      }

      // getPaperRequestListByPm()
      // getPaper()
    } else if (role === 'papersetter') {
      getPaperRequestForPsAndPa(selectedUser, 'paper_setter_id').then((data: any) => {
        data.paper_requests.forEach((eachRequest: any) => {
          let tempObj = eachRequest !== undefined && {
            'Paper Request': eachRequest?.name,
            'Paper Created': JSON.stringify(eachRequest?.paper?.[0]) !== '{}' ? (eachRequest?.papers?.length > 0 ? 1 : 0) : 0,
            'Paper Pending': eachRequest?.papers?.[0]?.status !== 'Approved' ? 1 : 0,
            'Paper For Approval': eachRequest?.papers?.[0]?.status === 'For Approval' ? 1 : 0,
            'Paper Approved': eachRequest?.papers?.[0]?.status === 'Approved' ? 1 : 0,
          }
          userDetails.push(tempObj)
        })
        setTableData(userDetails)
      })
    } else if (role === 'paperapprover') {
      getPaperRequestForPsAndPa(selectedUser, 'paper_approver_id').then((data: any) => {
        data.paper_requests.forEach((eachRequest: any) => {
          let tempObj = eachRequest !== undefined && {
            'Paper Request': eachRequest?.name,
            // 'Paper Created': JSON.stringify(eachRequest?.paper?.[0]) !== '{}' ? (eachRequest.papers.length > 0 ? 1 : 0) : 0,
            // 'Paper Pending': eachRequest?.papers?.[0]?.status !== 'Approved' ? 1 : 0,
            'Paper For Approval': eachRequest?.papers?.[0]?.status === 'For Approval' ? 1 : 0,
            'Paper Approved': eachRequest?.papers?.[0]?.status === 'Approved' ? 1 : 0,
          }
          userDetails.push(tempObj)
        })
        setTableData(userDetails)
      })
    } else if (role === 'deliverymanager') {
      getEvaluationRequestsByDm(selectedUser).then((data: any) => {
        data?.evaluation_requests?.forEach((evaluation_request: any) => {
          console.log('delivery manager data', evaluation_request)
          let evalRqstName = evaluation_request?.name
          let totalEvalCount = evaluation_request?.evaluators?.length
          let openEvalCount: number = 0
          let verifiedEvalCount: number = 0
          evaluation_request?.evaluators?.forEach((evaluation: any) => {
            evaluation.status === 'Open' ? openEvalCount++ : verifiedEvalCount++
          })
          let tempObj = {
            'Evaluation Requests': evalRqstName,
            'Total Evaluations': totalEvalCount,
            'Evaluations Open': openEvalCount,
            'Evaluations Verified': verifiedEvalCount,
          }
          userDetails.push(tempObj)
        })
        setTableData(userDetails)
      })
    } else if (role === 'evaluationincharge') {
      getEvaluationRequestsByEvaluationIncharge(selectedUser).then((data: any) => {
        data?.evaluation_requests?.forEach((evalRequest: any) => {
          let tempObj: any = {
            'Evaluation Requests': evalRequest?.name,
            'Evaluations Created': 0,
            'Evaluations Open': 0,
            'Evaluations Verified': 0,
          }
          evalRequest?.evaluators?.forEach((evaluation: any) => {
            tempObj['Evaluations Created']++
            evaluation.status === 'Open' ? tempObj['Evaluations Open']++ : tempObj['Evaluations Verified']++
          })
          userDetails.push(tempObj)
        })
        setTableData(userDetails)
      })
    } else if (role === 'evaluators') {
      // getEvaluationByEvaluator(selectedUser).then((data: any) => {
      //   let evalRqstObj:any = {}
      //   data?.evaluation_evaluators?.forEach((evaluation: any) => {
      //     let status = evaluation?.status
      //     let eval_rqst_name:string = evaluation?.evaluation_request?.name
      //     let eval_open = 0,
      //       eval_verified = 0
      //     status === 'Verified' ? eval_verified++ : eval_open++
      //     evalRqstObj[eval_rqst_name][eval_open] = parseInt(evalRqstObj[eval_rqst_name][eval_open]) + eval_open
      //     evalRqstObj[eval_rqst_name][eval_verified] = parseInt(evalRqstObj[eval_rqst_name][eval_open]) + eval_verified
      //   })
      // })
      getEvaluationRequestList().then((data: any) => {
        data?.evaluation_requests?.map((evalRequest: any) => {
          if (evalRequest?.evaluator_ids.includes(selectedUser)) {
            let tempObj: any = {
              'Evaluation Requests': evalRequest?.name,
              'Evaluations Assigned': 0,
              'Evaluations Open': 0,
              'Evaluations Verified': 0,
            }
            evalRequest?.evaluators?.forEach((evaluation: any) => {
              if (evaluation?.evaluator_id === selectedUser) {
                tempObj['Evaluations Assigned']++
                evaluation?.status === 'Open' ? tempObj['Evaluations Open']++ : tempObj['Evaluations Verified']++
              }
            })

            userDetails.push(tempObj)
          }
        })

        setTableData(userDetails)
      })
    }
  }, [selectedUser, reportType])

  const ShowCreator = [
    {
      title: 'Work Request Name',
      dataIndex: 'Work Request Name',
      key: 'Work Request Name',
    },
    {
      title: 'Total No of Questions',
      dataIndex: 'Total No of Questions',
      key: 'Total No of Questions',
    },
    {
      title: 'Total No of Questions Created',
      dataIndex: 'Total No of Questions Created',
      key: 'Total No of Questions Created',
    },
    {
      title: 'For Approval',
      dataIndex: 'For Approval',
      key: 'For Approval',
    },
    {
      title: 'For Review',
      dataIndex: 'For Review',
      key: 'For Review',
    },
    {
      title: 'For Review (Require Amending)',
      dataIndex: 'For Review (Require Amending)',
      key: 'For Review (Require Amending)',
    },
    {
      title: 'Open',
      dataIndex: 'Open',
      key: 'Open',
    },
    {
      title: 'Open (Require Amending)',
      dataIndex: 'Open (Require Amending)',
      key: 'Open (Require Amending)',
    },
    {
      title: 'Published',
      dataIndex: 'Published',
      key: 'Published',
    },
    {
      title: 'Rejected at Approval',
      dataIndex: 'Rejected at Approval',
      key: 'Rejected at Approval',
    },
    {
      title: 'Rejected at Review',
      dataIndex: 'Rejected at Review',
      key: 'Rejected at Review',
    },
    {
      title: 'Retired',
      dataIndex: 'Retired',
      key: 'Retired',
    },
  ]

  const ShowApprover = [
    {
      title: 'Work Request Name',
      dataIndex: 'Work Request Name',
      key: 'Work Request Name',
    },
    {
      title: 'Total No of Questions',
      dataIndex: 'Total No of Questions',
      key: 'Total No of Questions',
    },
    {
      title: 'Total No of Questions Approved',
      dataIndex: 'For Approval',
      key: 'For Approval',
    },
    {
      title: 'Open',
      dataIndex: 'Open',
      key: 'Open',
    },
    {
      title: 'Open (Require Amending)',
      dataIndex: 'Open (Require Amending)',
      key: 'Open (Require Amending)',
    },
    {
      title: 'For Review (Require Amending)',
      dataIndex: 'For Review (Require Amending)',
      key: 'For Review (Require Amending)',
    },
    {
      title: 'Published',
      dataIndex: 'Published',
      key: 'Published',
    },
    {
      title: 'Rejected at Approval',
      dataIndex: 'Rejected at Approval',
      key: 'Rejected at Approval',
    },
    {
      title: 'Retired',
      dataIndex: 'Retired',
      key: 'Retired',
    },
  ]

  const ShowReviewer = [
    {
      title: 'Work Request Name',
      dataIndex: 'Work Request Name',
      key: 'Work Request Name',
    },
    {
      title: 'Total No of Questions',
      dataIndex: 'Total No of Questions',
      key: 'Total No of Questions',
    },
    {
      title: 'Total No of Questions Reviewer',
      dataIndex: 'For Review',
      key: 'For Review',
    },
    {
      title: 'For Review (Require Amending)',
      dataIndex: 'For Review (Require Amending)',
      key: 'For Review (Require Amending)',
    },
    {
      title: 'Open',
      dataIndex: 'Open',
      key: 'Open',
    },
    {
      title: 'Open (Require Amending)',
      dataIndex: 'Open (Require Amending)',
      key: 'Open (Require Amending)',
    },
    {
      title: 'Published',
      dataIndex: 'Published',
      key: 'Published',
    },
    {
      title: 'Rejected at Review',
      dataIndex: 'Rejected at Review',
      key: 'Rejected at Review',
    },
    {
      title: 'Retired',
      dataIndex: 'Retired',
      key: 'Retired',
    },
  ]

  const ShowSubjectinCharge = [
    {
      title: 'Work Request Name',
      dataIndex: 'Work Request Name',
      key: 'Work Request Name',
    },
    {
      title: 'Total No of Questions',
      dataIndex: 'Total No of Questions',
      key: 'Total No of Questions',
    },
    {
      title: 'Total No of Questions Created',
      dataIndex: 'Total No of Questions Created',
      key: 'Total No of Questions Created',
    },
    {
      title: 'For Approval',
      dataIndex: 'For Approval',
      key: 'For Approval',
    },
    {
      title: 'For Review',
      dataIndex: 'For Review',
      key: 'For Review',
    },
    {
      title: 'For Review (Require Amending)',
      dataIndex: 'For Review (Require Amending)',
      key: 'For Review (Require Amending)',
    },
    {
      title: 'Open',
      dataIndex: 'Open',
      key: 'Open',
    },
    {
      title: 'Open (Require Amending)',
      dataIndex: 'Open (Require Amending)',
      key: 'Open (Require Amending)',
    },
    {
      title: 'Published',
      dataIndex: 'Published',
      key: 'Published',
    },
    {
      title: 'Rejected at Approval',
      dataIndex: 'Rejected at Approval',
      key: 'Rejected at Approval',
    },
    {
      title: 'Rejected at Review',
      dataIndex: 'Rejected at Review',
      key: 'Rejected at Review',
    },
    {
      title: 'Retired',
      dataIndex: 'Retired',
      key: 'Retired',
    },
  ]

  const getQuestionStatus = (questions: any, status: any) => {
    let count = 0
    questions.forEach((element: any) => {
      if (element.status === status) {
        count++
      }
    })
    return count
  }

  const reportfun = () => {
    setUserTable(tableData)
    if (role === 'qcreator' || role === 'variantcreator') {
      setShowList(ShowCreator)
    } else if (role === 'qapprover') {
      setShowList(ShowApprover)
    } else if (role === 'qreviewer') {
      setShowList(ShowReviewer)
    } else if (role === 'subjectincharge') {
      setShowList(ShowSubjectinCharge)
    } else if (role === 'papersetter') {
      setShowList(showPaperSetter)
    } else if (role === 'paperapprover') {
      setShowList(showPaperApprover)
    } else if (role === 'productmanager') {
      if (reportType === 'paper_requests') {
        setShowList(showProductManager)
      } else if (reportType === 'test_tracks') {
        setShowList(showProductManagerTestTrack)
      } else if (reportType === 'paper_templates') {
        setShowList(showProductManagerPaperTemplates)
      } else if (reportType === 'products') {
        setShowList(showProductManagerProducts)
      }
    } else if (role === 'deliverymanager') {
      setShowList(showDeliveryManager)
    } else if (role === 'evaluationincharge') {
      setShowList(showEvaluationIncharge)
    } else if (role === 'evaluators') {
      setShowList(showEvaluator)
    }
  }

  return (
    <List>
      <div>
        <Form form={form} requiredMark={true} style={{ display: 'flex' }}>
          <Form.Item name="userrole" label={'User Role'} rules={[{ required: true }]} style={{ marginBottom: '12px' }}>
            <Select
              onChange={(value: string) => {
                {
                  setRole(value)
                  form?.setFieldsValue({ user: '', report_type: '' })
                }
              }}
              onClick={e => e.stopPropagation()}
              size="large"
              style={{ width: '150px' }}
            >
              {roleList?.length > 0 &&
                roleList?.map(
                  item =>
                    item?.role !== 'user' &&
                    item?.role !== 'me' && (
                      <option key={item?.role} value={item?.role}>
                        {item?.role}
                      </option>
                    )
                )}
            </Select>
          </Form.Item>

          <Form.Item name="user" label={'User'} rules={[{ required: true }]} style={{ marginLeft: '35px', marginBottom: '12px' }}>
            <Select
              onChange={(value: string) => {
                setSelectedUser(value)
                form?.setFieldsValue({ report_type: '' })
              }}
              onClick={e => e.stopPropagation()}
              size="large"
              style={{ width: '150px' }}
            >
              {userList?.length > 0 &&
                userList?.map(item => (
                  <Option key={item?.user?.id} value={item?.user?.id}>
                    {item?.user?.displayName}
                  </Option>
                ))}
            </Select>
          </Form.Item>

          {role === 'productmanager' ? (
            <Form.Item name="report_type" label="Report Type" rules={[{ required: true }]} style={{ marginLeft: '35px', marginBottom: '12px' }}>
              <Select
                options={productManagerOptions}
                size="large"
                style={{ width: '150px' }}
                onClick={e => e.stopPropagation()}
                onChange={value => {
                  setReportType(value)
                }}
              />
            </Form.Item>
          ) : null}

          <Button onClick={reportfun} style={{ marginTop: '3px', marginLeft: '15px', backgroundColor: 'skyblue' }}>
            <ArrowDownOutlined />
            See Report
          </Button>
        </Form>
        <div>
          <CSVLink
            data={userTable}
            asyncOnClick={true}
            filename={`Work_Request_${selectedUserName}_${Math.round(new Date().getTime() / 1000)}.xlsx`}
            className="ant-btn ant-btn-default"
          >
            <ExportOutlined /> Report
          </CSVLink>
        </div>
      </div>
      <Table dataSource={userTable} columns={showlist} />
    </List>
  )
}
